/* eslint-disable sonarjs/cognitive-complexity, unicorn/consistent-function-scoping */

;(function () {
  'use strict'

  const SWIPE_THRESHOLD_PX = 50

  function onDocumentReady() {
    const galleries = document.querySelectorAll('.cmp-image-gallery')

    for (const gallery of galleries) {
      if (gallery.classList.contains('cmp-image-gallery--inline')) {
        continue
      }

      const slides = gallery.querySelectorAll('.cmp-image-gallery__slide')
      const sliderContainer = gallery.querySelector('.cmp-image-gallery__slides')
      const previousButton = gallery.querySelector('.cmp-image-gallery__navigation-button--previous')
      const nextButton = gallery.querySelector('.cmp-image-gallery__navigation-button--next')
      let currentSlide = 0

      // The track needs to shift left by the combined width of every slide
      // BEFORE the active one - all of which render at the non-active width,
      // not the (wider) active width. Slide 0 is only ever non-active when
      // currentSlide isn't 0, so it's a safe stand-in for that width/margin
      // regardless of how many preceding slides there are.
      function updateSlidePosition() {
        if (currentSlide === 0) {
          sliderContainer.style.transform = 'translateX(0px)'
          return
        }

        const referenceSlide = slides[0]
        const slideWidth = referenceSlide.getBoundingClientRect().width
        const slideMarginRight = Number.parseFloat(window.getComputedStyle(referenceSlide).marginRight) || 0
        const offset = -currentSlide * slideWidth - currentSlide * slideMarginRight
        sliderContainer.style.transform = `translateX(${offset}px)`
      }

      function updateActiveClass() {
        for (const [index, slide] of slides.entries()) {
          slide.classList.toggle('cmp-image-gallery__slide--active', index === currentSlide)
          slide.setAttribute('aria-hidden', index !== currentSlide)
          slide.tabIndex = index === currentSlide ? 0 : -1
        }
        sliderContainer.style.height = `${slides[currentSlide].clientHeight}px`
      }

      function goToSlide(index) {
        currentSlide = index
        updateSlidePosition()
        updateActiveClass()
        updateNavigationState()
      }

      function updateNavigationState() {
        previousButton.disabled = currentSlide === 0
        nextButton.disabled = currentSlide === slides.length - 1
      }

      function handleKeyDown(event) {
        if (event.key === 'ArrowLeft') {
          goToSlide(Math.max(0, currentSlide - 1))
        } else if (event.key === 'ArrowRight') {
          goToSlide(Math.min(slides.length - 1, currentSlide + 1))
        }
      }

      previousButton.addEventListener('click', () => {
        goToSlide(Math.max(0, currentSlide - 1))
      })

      nextButton.addEventListener('click', () => {
        goToSlide(Math.min(slides.length - 1, currentSlide + 1))
      })

      for (const [index, slide] of slides.entries()) {
        slide.addEventListener('click', () => {
          if (index !== currentSlide) {
            goToSlide(index)
          }
        })
      }

      let touchStartX = 0
      let touchStartY = 0
      let isHorizontalSwipe = false

      sliderContainer.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.touches[0]
          touchStartX = touch.clientX
          touchStartY = touch.clientY
          isHorizontalSwipe = false
        },
        { passive: true },
      )

      sliderContainer.addEventListener(
        'touchmove',
        (event) => {
          const touch = event.touches[0]
          const diffX = touch.clientX - touchStartX
          const diffY = touch.clientY - touchStartY
          if (Math.abs(diffX) > Math.abs(diffY)) {
            isHorizontalSwipe = true
            event.preventDefault()
          }
        },
        { passive: false },
      )

      sliderContainer.addEventListener('touchend', (event) => {
        if (!isHorizontalSwipe) {
          return
        }

        const touch = event.changedTouches[0]
        const diffX = touch.clientX - touchStartX
        if (Math.abs(diffX) < SWIPE_THRESHOLD_PX) {
          return
        }

        if (diffX < 0) {
          goToSlide(Math.min(slides.length - 1, currentSlide + 1))
        } else {
          goToSlide(Math.max(0, currentSlide - 1))
        }
      })

      document.addEventListener('keydown', handleKeyDown)
      window.addEventListener('resize', () => {
        updateSlidePosition()
        updateActiveClass()
      })

      updateActiveClass()
      updateNavigationState()
    }
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
